<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("heading.tourism-cities") }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="ShowMyFormDialoge">{{
        $t("button.create")
      }}</v-btn>
    </v-toolbar>

    <!-- table -->
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      pathName="tourism-cities"
      resName="tourism_cities"
      class="table-row"
      :imagePath="imagePath"
      :overlay.sync="overlay"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">
          <v-avatar @click="showImage(item)">
            <img
              style="cursor: pointer"
              :src="item.main_media ? item.main_media.path : dummyIcon"
              alt="Icon"
            />
          </v-avatar>
        </td>
        <td class="text-sm-center">
          {{ item.name ? item.name : "" }}
        </td>
        <td class="text-sm-center">
          <span v-if="item.description">
            {{ item.description | truncate }}</span
          >
          <span v-else> -----</span>
        </td>
        <td v-if="item.country.name" class="text-sm-center">
          <v-chip color="primary">{{ item.country.name }}</v-chip>
        </td>

        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="tourism-cities"
            :model-id="item.id"
            field="visible"
            v-model="item.visible"
            :validate="true"
          />
        </td>

        <td class="text-center">
          <v-icon small class="mr-2 edit" @click="handleShow(item, index)">
            mdi-pencil
          </v-icon>
          <v-icon class="delete" small @click="deleteItem(item, index)">
            mdi-delete
          </v-icon>
        </td>
      </template>
    </wrapping-table>
    <FormAction
      :slug_category="item.slug"
      :isEdit="isEdit"
      :dialog.sync="dialog"
      @on-create="handleCreate"
      @on-update="handleUpdate"
      @on-refresh-table="handleRefresh"
    />
  </div>
</template>

<script>
// import cookie from "js-cookie";

export default {
  name: "TourismCities",
  components: {
    FormAction: () => import("./FormAction")
  },
  data() {
    return {
      dummyIcon: " https://via.placeholder.com/50x50?text=icon",
      headers: [
        "photo",
        "name",
        "description",
        "country",
        "visible",
        "actions"
      ],
      queries: {
        query: {
          visible: "",
          approved: ""
        }
      },
      locale: "en",
      loadingBtn: false,
      customQuery: {},
      dialog: false,

      isEdit: false,

      item: {},
      itemIndex: "",
      overlay: false,
      imagePath: ""
    };
  },

  methods: {
    handleRefresh() {
      this.$refs.table_ref.handleGetItems();
    },
    showImage({ main_media }) {
      this.imagePath = main_media.path;
      this.overlay = true;
    },
    handleCreate(data) {
      this.$refs.table_ref
        .handleOnCreate("tourism-cities", data, "tourism_city")
        .then(() => {
          this.dialog = false;
        });
    },
    handleUpdate(data) {
      this.$refs.table_ref
        .handleOnEdit(
          "tourism-cities",
          data,
          this.item.slug,
          "tourism_city",
          this.itemIndex
        )
        .then(() => {
          this.dialog = false;
        });
    },
    deleteItem({ slug }, index) {
      this.$refs.table_ref.handleDelete(slug, index);
    },

    handleShow(item, index) {
      this.item = item;
      this.itemIndex = index;
      this.dialog = true;
      this.isEdit = true;
    },
    ShowMyFormDialoge() {
      this.isEdit = false;
      this.dialog = true;
    }
  },
  watch: {
    dialog: {
      handler(value) {
        if (!value) {
          this.isEdit = false;
        }
      },
      immediate: true
    }
  }
};
</script>
